/**
 * Countries for an address: ISO 3166-1 alpha-2 codes, named by the browser
 * (`Intl.DisplayNames`), so the list is a list of codes and nothing to
 * translate or keep spelled right. The code is what is stored — the R&D
 * report reads "US" or not.
 */
const CODES =
  'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'.split(
    ' ',
  );

let names: Intl.DisplayNames | null = null;
/** "MX" → "Mexico". Falls back to the code where the browser has no name. */
export function countryName(code: string | null | undefined): string {
  if (!code) return '';
  try {
    names ??= new Intl.DisplayNames(['en'], { type: 'region' });
    return names.of(code) ?? code;
  } catch {
    return code;
  }
}

/** The US first (most of the team, and the R&D credit's line), then A–Z by name. */
export function countryOptions(): Array<{ value: string; label: string }> {
  const rest = CODES.filter((c) => c !== 'US')
    .map((c) => ({ value: c, label: countryName(c) }))
    .sort((a, b) => a.label.localeCompare(b.label));
  return [{ value: 'US', label: countryName('US') }, ...rest];
}
